import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import ErrorIcon from '@mui/icons-material/Error'
import LoopIcon from '@mui/icons-material/Loop'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid2'
import IconButton from '@mui/material/IconButton'
import ImageListItem from '@mui/material/ImageListItem'
import Tooltip from '@mui/material/Tooltip'
import { findIndex } from 'lodash'
import { useState } from 'react'
import { useRequestsStore } from '../../../../store/storeRequests'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { DownloadImageButton } from './DownloadImageButton'
import { Image } from './Image'

export const ImageInRequest = ({ src, tastId, isAssistant }) => {
    const { filesInRequest, setFilesInRequest, isCanFilesInRequest } = useRequestsStore(
        (state) => state,
    )

    const [isDoneLoading, setIsDoneLoading] = useState(false)
    const [isErrorLoading, setIsErrorLoading] = useState(false)
    const { modelDetail } = useWrapperStore((state) => state)

    const handleClickFileAdd = (url) => {
        const filesInRequestBuff = filesInRequest ? [...filesInRequest] : []

        filesInRequestBuff.push({ name: url, size: -1 })

        setFilesInRequest(filesInRequestBuff)
    }

    return (
        <ImageListItem sx={{ display: 'flex', width: 'fit-content' }}>
            {!isErrorLoading && !isDoneLoading && <CircularProgress size={40} sx={{ m: 2 }} />}
            {isErrorLoading && (
                <Box
                    sx={{
                        width: '100%',
                        my: 2,
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                    <ErrorIcon color="error" sx={{ mr: 1 }} />
                    Возникла ошибка загрузки изображения!
                </Box>
            )}
            <Image
                isDoneLoading={isDoneLoading}
                isAssistant={isAssistant}
                onLoad={() => setIsDoneLoading(true)}
                onError={() => setIsErrorLoading(true)}
                src={src}
            />
            {isDoneLoading && isAssistant && (
                <Grid
                    container
                    spacing={1}
                    sx={{
                        display: 'flex',
                        p: 3,
                        position: 'absolute',
                        top: '0',
                        right: '0',
                        flexDirection: 'column',
                    }}>
                    {tastId &&
                        modelDetail?.series?.additional_actions &&
                        findIndex(modelDetail.series.additional_actions, { name: 'reroll' }) !==
                            -1 && (
                            <Tooltip title="Перегенерировать изображение">
                                <IconButton
                                    onClick={handleClickRegenerateImage}
                                    sx={{
                                        color: '#fff',
                                        background: '#605c5c',
                                        borderRadius: '32px',
                                    }}>
                                    <LoopIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                    <DownloadImageButton src={src} />
                    {isCanFilesInRequest && (
                        <Tooltip title="Прикрепить">
                            <IconButton
                                sx={{ color: '#fff', background: '#605c5c', borderRadius: '32px' }}
                                onClick={() => handleClickFileAdd(src)}>
                                <AttachFileOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                </Grid>
            )}
        </ImageListItem>
    )
}
